export function ArvGalleryIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_arv_gallery)">
        <path d="M0.765625 12.061L2.55512 10.2888C3.33 9.52135 4.55066 9.43888 5.42175 10.0951L5.99084 10.5238C6.67516 11.0393 7.64259 10.9325 8.198 10.2801L9.66444 8.55763C10.5162 7.55707 12.0502 7.52357 12.9449 8.48594L15.3476 11.0704" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.71494 7.17695C6.52832 7.17695 7.18769 6.51757 7.18769 5.7042C7.18769 4.89082 6.52832 4.23145 5.71494 4.23145C4.90156 4.23145 4.24219 4.89082 4.24219 5.7042C4.24219 6.51757 4.90156 7.17695 5.71494 7.17695Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.5033 14.3231C14.5373 14.3213 15.375 13.4825 15.375 12.4481V3.55176C15.375 2.51623 14.5355 1.67676 13.5 1.67676H2.5C1.46447 1.67676 0.625 2.51623 0.625 3.55176V12.4481C0.625 13.4836 1.46447 14.3231 2.5 14.3231H10.3783" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_arv_gallery">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
